import type { SeparationQuestion } from '@/features/onboarding/separation'
import { transactionIdsOf } from '@/features/onboarding/separation/transactionIds'

/**
 * The groups a refetch turned up that the queue should still ask about.
 *
 * An account can finish separating while the user works through another one's groups, and
 * its groups would otherwise never be asked about. But a group promoted out of the deferred
 * list because answering freed up cap space looks exactly the same from here, so the queue
 * has to stop at the server's cap or it refills forever and the cap never binds.
 *
 * The server caps transfer and merchant questions together, so every queued question spends
 * the same budget.
 */
export const admittedQuestions = ({
  queue,
  refreshed,
  maxQuestions,
}: {
  queue: SeparationQuestion[]
  refreshed: SeparationQuestion[]
  maxQuestions: number
}): SeparationQuestion[] => {
  const queued = new Set(queue.flatMap(transactionIdsOf))
  const arrived = refreshed.filter((candidate) =>
    transactionIdsOf(candidate).some((id) => !queued.has(id))
  )

  const room = Math.max(maxQuestions - queue.length, 0)
  return arrived.slice(0, room)
}
